import React, { useState, useEffect } from "react";

export default function PaywithCard(props) {
    const [sellItem, setSellItem] = useState({})
    const CloseDialog = () => {
        props.fucn()
    }

    return (
        <>

           <div className="position-relative">
            <div className="dialogHeader border-0 position-absolute end-0 top-0 p-0 mt-3">
            <button onClick={CloseDialog}>
              <i className="fa-regular fa-xmark"></i>
            </button>
          </div>
             <div className="row">
                <div className="col-xl-6 pt-5 ps-5">
                    <img src="/images/svg/coming-soon-card.svg" className="img-fluid" />
                </div>
                <div className="col-xl-6 my-auto comingsooncard pe-5">
                    <h1>Credit Card payments<br />
                        <span>Coming soon</span></h1>
                    <p>We're adding credit card support to make checkout easier. Stay tuned for updates!</p>
                    {/* <button onClick={CloseDialog}>Close</button> */}
                </div>
            </div>
           </div>
        </>
    )
}